/**
 * Default configuration
 * @type {Object}
 */
export const config = {
  disqusShortname: 'gremlin-2',
  algolia: {
    applicationId: 'TQAWOMSD2N',
    apiKey: 'dc02058ec9ccc41e3a77c4fb82206b8a',
  },
  latestSecurityFAQ:
    'https://res.cloudinary.com/gremlin/image/upload/v1558365100/20190214_Security_FAQ.pdf',
  demoVideoEmbed:
    'https://www.youtube.com/embed/roCao6xuyC4?modestbranding=1&rel=0&showinfo=0&autohide=1&autoplay=1',
  scenariosVideoEmbed:
    'https://www.youtube.com/embed/2sXTbHSKHZA?modestbranding=1&rel=0&showinfo=0&autohide=1&autoplay=1',
};
